import React from "react";

function LoginFormV2({ handleSubmit, credentials, handleChange, loading, setShowForgotPassword, theme }) {
  return (
    <form onSubmit={handleSubmit} className="flex flex-col h-[30rem] justify-around ">
      <div className="space-y-6 pb-5">
        {/* Email Field */}
        <div>
          <label htmlFor="username" className="block text-2xl font-medium text-zinc-200 mb-2">
            Nombre de Usuario
          </label>
          <input
            type="text"
            id="username"
            name="username"
            value={credentials.username}
            onChange={handleChange}
            className="w-full text-2xl px-4 py-3 rounded-2xl focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition-all text-white"
            style={{
              backgroundColor: theme.colors.tertiary_dark,
              border: "1px solid" + theme.colors.tertiary_dark,
              color: theme.colors.text_login_light,
            }}
            required
          />
        </div>

        {/* Password Field */}
        <div>
          <label htmlFor="password" className="block text-2xl font-medium text-zinc-200 mb-2">
            Contraseña
          </label>
          <input
            type="password"
            id="password"
            name="password"
            value={credentials.password}
            onChange={handleChange}
            className="w-full px-4 py-3 text-2xl tablet:text-lg rounded-2xl focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition-all text-white"
            style={{
              backgroundColor: theme.colors.tertiary_dark,
              border: "1px solid" + theme.colors.tertiary_dark,
              color: theme.colors.text_login_light,
            }}
            required
          />
        </div>

        {/* Forgot Password */}
        <div className="text-right">
          <button
            type="button"
            onClick={() => setShowForgotPassword(true)}
            className="text-[15px] text-zinc-200 hover:text-zinc-400 transition-colors"
          >
            Olvidaste tu contraseña?
          </button>
        </div>
      </div>

      {/* Grupo Inferior: Botones */}
      <div className="space-y-4 mb-3">
        {/* Sign In Button */}
        <button
          type="submit"
          disabled={loading}
          style={{
            backgroundColor: theme.colors.tertiary_dark,
            color: theme.colors.text_login_light,
          }}
          className="w-full text-[18px] text-white font-semibold py-3 px-4 rounded-full hover:opacity-90 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {loading ? "Iniciando sesión..." : "Iniciar sesión"}
        </button>
        {/* Register Link */}
        {/* <div className="flex items-center justify-center gap-2 ">
          <p className="text-zinc-300 text-[12px] tablet:text-[14px]">¿No tienes una cuenta?</p>
          <a href="https://extranet.inatrans.cl/pre-inscription"
            type="button"
            className="text-[#44BCF9] hover:text-[#41Bad8] text-[15px] tablet:text-[18px] font-medium cursor-pointer transition-colors duration-200 hover:underline focus:outline-none focus:underline"
          >
            Regístrate aquí
          </a>
        </div> */}
      </div>
    </form>
  );
}

export default LoginFormV2;
